import Loading from 'quasar/src/plugins/loading/Loading.js';
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import BukenRoomList from "~/components/BukenRoomList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { PageID } from "~/extensions/utils/DefineTypes";
import ShomeiListTable from "~/pages/shomei/components/ShomeiListTable.vue";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
const log = Log.create("ShomeiListPage");
export default defineComponent({
    name: "ShomeiListPage",
    components: {
        BukenRoomList,
        ShomeiListTable,
        BreadcrumbList
    },
    setup() {
        // 画面名取得
        const pageName = commonStore.pageName(PageID.shomeiList);
        const router = useRouter();
        const isVisibleRange = ref(false);
        let htmlRange = reactive({
            value: ""
        });
        let tuisekiLink = ref("");
        // 初期表示処理
        const initView = async () => {
            try {
                Loading.show();
                htmlRange.value = await api.shomei.loadEntryRangeText();
                tuisekiLink.value = await api.shomei.loadTuisekiLink();
                updateIsVisibleRange(htmlRange.value);
            }
            catch (ex) {
                log.error("setup", ex);
                MsgBox.error(ex.message);
            }
            finally {
                Loading.hide();
            }
        };
        // htmlの表示期間チェック
        const updateIsVisibleRange = (html) => {
            if (!html) {
                return;
            }
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const start = doc.querySelector('meta[name="display-start"]')?.getAttribute("content");
            const end = doc.querySelector('meta[name="display-end"]')?.getAttribute("content");
            if (!start || !end) {
                isVisibleRange.value = false;
                return;
            }
            const today = new Date().setHours(0, 0, 0, 0);
            const startDate = new Date(start);
            const endDate = new Date(end);
            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                isVisibleRange.value = false;
                return;
            }
            isVisibleRange.value = startDate.setHours(0, 0, 0, 0) <= today && today <= endDate.setHours(0, 0, 0, 0);
        };
        //新規発行ボタン押下
        const onClick = () => {
            Loading.show();
            if (myPageStore.isMultipleKeiyaku) {
                router.push({ name: "shomei-room-list" });
            }
            else {
                router.push({ name: "shomei-precautions" });
            }
            Loading.hide();
        };
        onMounted(async () => {
            await initView();
        });
        return {
            pageName,
            PageID,
            myPageStore,
            htmlRange,
            isVisibleRange,
            tuisekiLink,
            onClick
        };
    }
});
